export default {   
    // getCookie    
    getCookie: function(name) {        
        var arr, reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");        
        if(arr = document.cookie.match(reg)) {            
            return unescape(arr[2]);        
        } else {            
            return null;        
        }    
    },
    // getPvId    
    generateRand: function() {        
        var rands = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'     
        var arr = new Array(7)  
        var pvId;      
        if(!window.randId){             
            for (var i = 0; i < arr.length; i++) {                
                arr[i] = rands[parseInt(Math.random() * rands.length)]            
            }           
        window.randId = arr.join('')       
        }        
       return pvId = new Date().getTime() + window.randId 
    }
}


// WEBPACK FOOTER //
// ./src/components/helper/getCookie.js